<template>
	<div class="header_box">
		<div class="header_ban">
			<div class="out_btn">
				<el-button type="text" icon="el-icon-back" @click="log_out" >退出</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		methods:{
			//登出
			log_out:function(){
				this.$emit("loginout");
			},
		}
	}
</script>

<style scoped>
	.header_box{
		width: 100%;
		height: 75px;
		background-color: #fff;
		box-shadow: 0px 0px 5px #ccc;
		padding-left: 210px;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 10;
	}
	.header_ban{
		width: 100%;
		position: relative;
	}
	.out_btn{
		height: 100%;
		padding: 0 15px;
		position: absolute;
		top: 15px;
		right: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/header.vue